/* ClientCharts auto-generated by npm run generator */
import { Client } from "@qlarity/common"
import ChartContainer from "components/atoms/ChartContainer"
import { observer } from "mobx-react"
import React from "react"
import CheckinChart from "./CheckinChart"
import MoodChart from "./MoodChart"

interface ClientChartsProps {
    client: Client
}

const ClientCharts: React.FC<ClientChartsProps> = (props) => {
    return (
        <ChartContainer title={`App Use Statistics: ${props.client.displayName}`}>
            <MoodChart checkins={[props.client.checkins]} />
            <CheckinChart client={props.client} />
        </ChartContainer>
    )
}

export default observer(ClientCharts)
